import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useColumn } from '../columns/column-context';
import { ColumnElementBase } from './column-element-base';
import { type ColumnElement } from './column-elements';

export function Picture({
  $alignRows: alignRows,
  ...forwardingProps
}: ColumnElement) {
  const { picture, title } = useColumn();
  const { alt, url } = picture ?? {};

  return (
    <Container $alignRows={alignRows} {...forwardingProps}>
      <MediaImage alt={alt ?? title} src={url} $withPadding={alignRows} />
    </Container>
  );
}

const Container = styled(ColumnElementBase).attrs({
  className: createReadableClass({ component: 'picture', element: 'container' })
})`
  position: relative;
  overflow: hidden;
  width: 100%;

  padding-top: ${({
    theme: {
      picture: { aspectRatio = 2 / 3 }
    }
  }) => 100 * aspectRatio}%;
`;

const MediaImage = styled.img.attrs({
  className: createReadableClass({ component: 'picture' })
})<{
  $withPadding: boolean;
}>`
  max-width: 100%;
  object-fit: cover;
  user-select: none;
  width: 100%;
  height: 100%;

  ${({
    theme: {
      picture: { aspectRatio }
    }
  }) =>
    !!aspectRatio &&
    css`
      top: 0;
      left: 0;
      position: absolute;
    `}

  ${({ $withPadding }) =>
    $withPadding &&
    css`
      padding: 0 1px;
    `}
`;
